(function() {
 'use strict';

 function initVATValidation(wrapper) {
 if (!wrapper || wrapper.dataset.vatInit === 'true') return;
 wrapper.dataset.vatInit = 'true';

 var companyField = wrapper.querySelector('[data-vat-company]');
 var vatField = wrapper.querySelector('[data-vat-number]');
 var marker = wrapper.querySelector('[data-vat-required-marker]');
 var errorMsg = wrapper.querySelector('[data-vat-error]');

 if (!companyField || !vatField) return;

 function updateRequirement() {
 var companyFilled = companyField.value.trim().length > 0;
 if (companyFilled) {
 if (marker) marker.style.display = 'inline';
 vatField.setAttribute('required', 'required');
 } else {
 if (marker) marker.style.display = 'none';
 vatField.removeAttribute('required');
 if (errorMsg) errorMsg.style.display = 'none';
 vatField.style.borderColor = '#ccc';
 }
 }

 function validate(e) {
 var companyFilled = companyField.value.trim().length > 0;
 var vatFilled = vatField.value.trim().length > 0;

 if (companyFilled && !vatFilled) {
 if (e) {
 e.preventDefault();
 e.stopPropagation();
 if (e.stopImmediatePropagation) {
 e.stopImmediatePropagation();
 }
 }
 if (errorMsg) errorMsg.style.display = 'block';
 vatField.style.borderColor = '#dc2626';
 try {
 vatField.scrollIntoView({
 behavior: 'smooth', block: 'center'
 });
 } catch (err) {}
 vatField.focus();
 return false;
 }
 return true;
 }

 companyField.addEventListener('input', updateRequirement);
 companyField.addEventListener('blur', updateRequirement);

 vatField.addEventListener('input', function() {
 if (vatField.value.trim().length > 0) {
 if (errorMsg) errorMsg.style.display = 'none';
 vatField.style.borderColor = '#ccc';
 }
 });

 // Find associated form — 2 ways:
 // 1. If input has form="..." attr (cart drawer case)
 // 2. Walk up the DOM to find parent form (cart page case)
 var form = null;
 var formId = vatField.getAttribute('form');
 if (formId) {
 form = document.getElementById(formId);
 }
 if (!form) {
 form = vatField.closest('form');
 }

 if (form) {
 form.addEventListener('submit', validate, true);
 // Also catch checkout buttons inside this form
 var btns = form.querySelectorAll('button[name="checkout"]');
 btns.forEach(function(btn) {
 btn.addEventListener('click', validate, true);
 });
 }

 // Catch checkout buttons via form attribute (drawer case)
 if (formId) {
 var externalBtns = document.querySelectorAll(
 'button[form="' + formId + '"][name="checkout"]'
 );
 externalBtns.forEach(function(btn) {
 btn.addEventListener('click', validate, true);
 });
 }

 updateRequirement();
 }
 function initAll() {
 var wrappers = document.querySelectorAll('[data-vat-wrapper]');
 wrappers.forEach(initVATValidation);
 }

 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', initAll);
 } else {
 initAll();
 }

 // Re-init when cart drawer updates (Minimog dispatches custom events)
 document.addEventListener('cart:updated', initAll);
 document.addEventListener('cart:refresh', initAll);

 // Observe DOM for dynamically inserted wrappers
 if (window.MutationObserver) {
 var observer = new MutationObserver(function(mutations) {
 for (var i = 0; i < mutations.length; i++) {
 if (mutations[i].addedNodes.length > 0) {
 initAll();
 break;
 }
 }
 });
 observer.observe(document.body, {
 childList: true, subtree: true
 });
 }
})();